import { c as _c } from "react/compiler-runtime";
import { ImageLoader } from 'next/image';
import imageLoader from '@spa/lib/image-loader/imageLoader';
import { useMemo } from 'react';
const useImagesLoader = t0 => {
  const $ = _c(2);
  const enableNextJsLoader = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== enableNextJsLoader) {
    t1 = props => imageLoader(props, enableNextJsLoader);
    $[0] = enableNextJsLoader;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default useImagesLoader;